import {useMemo} from 'react';

import {LogLoadingContext, LogLoadingIndicator} from '../LogLoadingIndicator';

/**
 * useVirtuosoComponents creates cached component classes used for the
 * `LogViewer`'s header and footer elements. These are generally only displayed
 * when new logs are being fetched.
 */
export function useVirtuosoComponents({
  isLoadingPrevious,
}: {
  isLoadingPrevious: boolean;
}) {
  // Virtuoso accepts an object containing various components by key. This only
  // needs to be created once, so memoize without dependencies.
  const components = useMemo(
    () => ({
      Header: LogLoadingIndicator,
    }),
    []
  );

  const context = useMemo<LogLoadingContext>(
    () => ({
      isLoadingPrevious: isLoadingPrevious,
    }),
    [isLoadingPrevious]
  );

  return useMemo(
    () => ({
      components,
      context,
    }),
    [components, context]
  );
}
